import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';

import { GroupsState } from '../state';

// slice off the group state from the whole app store.
export const getGroupsState: MemoizedSelector<any, GroupsState> = createFeatureSelector<GroupsState>('groups');
